import type { TemplateCategory } from '../models/contract-template.model';

// Injection token + contract for opening the upload-template-contract dialog. A modal can request the
// upload flow through this token without importing the modal component, which would reintroduce the
// upload <-> preview circular dependency. TemplateDialogService is the concrete provider.
export abstract class ContractTemplateUploadDialog {
  abstract openUpload(data?: { category?: TemplateCategory }): void;
  /** The manual flow, even where the AI builder would open. */
  abstract openManualUpload(data?: { category?: TemplateCategory }): void;
}
